import React, { useEffect, useState } from 'react'
import { useMsal } from '@azure/msal-react'
// import '../pages/tokenexpiration/TokenExpirationHandlerPopup.css'
import { RhyBusButton as Buttons } from '@rhybus/button'
import { USER_SESSION_ID } from '../config/session-constants'
import { AUTH_PROVIDER } from '../authProvider'
import { keycloakLogout } from '../authKeycloak'

const SignOutOverlay = () => {
  const { instance } = useMsal()
  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    const handleAuthRequired = () => {
      setShowOverlay(true)
    }

    window.addEventListener('rhybus-auth-required', handleAuthRequired)
    return () => {
      window.removeEventListener('rhybus-auth-required', handleAuthRequired)
    }
  }, [])
  const handleSignOut = () => {
    localStorage.removeItem(USER_SESSION_ID)
    localStorage.removeItem('RHYBUS_ACCESS_TOKEN')
    localStorage.removeItem('RHYBUS_REFRESH_TOKEN')
    localStorage.removeItem('OTP_LOGIN')

    if (AUTH_PROVIDER === 'keycloak') {
      keycloakLogout().catch(() => {
        window.location.href = '/login'
      })
      return
    }

    instance.logoutRedirect()
      .catch(() => {
        window.location.href = '/login'
      })
  }

  if (!showOverlay) return null

  return (
    <div className="popup-overlay token-expiration-popup">
      <div className="popup session-expire-popup p-3">
        <h2 className='m-0 mb-1'>Session Expired</h2>
        <p className='mb-2'>Your roles or permissions have been updated. Please sign out and sign back in to continue.</p>
        <Buttons
          className="btn-sm segoeui-semibold btn-primary whitetext mx-auto"
          label=" Sign Out"
          onClick={handleSignOut}
        />
      </div>
    </div>
  )
}

export default SignOutOverlay
